(function () {
	"use strict";

	angular.module("qbePortal").service("smartLinkService", smartLinkService);

	function smartLinkService() {
		this.generateLink = generateLink;

		function generateLink(customerData) {
			// JS Implementation of the buildSmartlink code
			var url = customerData.smartLinkURL; //do not change this
			var sharedkey = customerData.hashKey;

			//required arguments
			var merchantidentifer = "qbe-insurance"; // your feefo merchant identifier. This account must have Smartlink activated.
			var name = customerData.policyHolderName; // the customer name
			var email = customerData.email; // the customer email address
			var orderref =
				customerData.policyNumber != null
					? customerData.policyNumber
					: undefined; // your unique order reference number

			var descriptions = [customerData.description]; // description(s) of item(s) purchased

			var productrefs = [customerData.productRefs]; // product ref(s) of items purchased - usually SKU or equivalent

			// recommended arguments
			var date = moment().tz("Australia/Sydney").format("YYYY-MM-DD"); // date of the transaction

			var productlink; // URL to web page of product(s) purchased

			// variable list ends - we now have all the inforamtion we need to build a SmartLink

			// Do not change the variables immediately below
			var markerstart = "|!";
			var markers = {
				EMAIL: "B",
				NAME: "C",
				DATE: "D",
				FEEDBACKDATE: "E",
				DESCRIPTION: "F",
				LINK: "G",
				PRODUCTREF: "H",
				ORDERREF: "I",
				AMOUNT: "J",
				CURRENCY: "K",
				CUSTOMERREF: "M",
				MERCHANTIDENTIFIER: "N",
				TAG: "O",
			};

			// this "if" checks that all required fields exist and are not empty

			if (
				typeof merchantidentifer !== "undefined" &&
				merchantidentifer.length > 0 &&
				typeof email !== "undefined" &&
				email.length > 0 &&
				typeof name !== "undefined" &&
				name.length > 0 &&
				typeof descriptions !== "undefined" &&
				descriptions.length > 0 &&
				typeof productrefs !== "undefined" &&
				productrefs.length > 0 &&
				typeof orderref !== "undefined" &&
				orderref.length > 0
			) {
				// this enormous "if" checks whether the multiline fields all have the same number of items

				if (
					descriptions.length == productrefs.length &&
					(typeof productlinks === "undefined" ||
						productlinks.length == descriptions.length) &&
					(typeof tags === "undefined" ||
						tags.length == descriptions.length) &&
					(typeof amounts === "undefined" ||
						amounts.length == descriptions.length)
				) {
					var initialparams = "";
					initialparams +=
						markerstart +
						markers.MERCHANTIDENTIFIER +
						merchantidentifer;
					initialparams += markerstart + markers.EMAIL + email;
					initialparams += markerstart + markers.NAME + name;
					initialparams += markerstart + markers.ORDERREF + orderref;
					if (typeof date !== "undefined" && date.length > 0) {
						initialparams += markerstart + markers.DATE + date;
					}

					if (
						typeof customerref !== "undefined" &&
						customerref.length > 0
					) {
						initialparams +=
							markerstart + markers.CUSTOMERREF + customerref;
					}
					if (
						typeof feedbackdate !== "undefined" &&
						feedbackdate.length > 0
					) {
						initialparams +=
							markerstart + markers.FEEDBACKDATE + feedbackdate;
					}
					if (
						typeof currencyid !== "undefined" &&
						currencyid.length > 0
					) {
						initialparams +=
							markerstart + markers.CURRENCY + currencyid;
					}
					for (var count = 1; count <= descriptions.length; count++) {
						initialparams +=
							markerstart +
							markers.DESCRIPTION +
							count +
							descriptions[count - 1];
					}
					for (var count = 1; count <= productrefs.length; count++) {
						initialparams +=
							markerstart +
							markers.PRODUCTREF +
							count +
							productrefs[count - 1];
					}
					if (typeof productlinks !== "undefined") {
						for (
							var count = 1;
							count <= productlinks.length;
							count++
						) {
							initialparams +=
								markerstart +
								markers.LINK +
								count +
								productlinks[count - 1];
						}
					}
					if (typeof amounts !== "undefined") {
						for (var count = 1; count <= amounts.length; count++) {
							initialparams +=
								markerstart +
								markers.AMOUNT +
								count +
								amounts[count - 1];
						}
					}
					if (typeof tags !== "undefined") {
						for (var count = 1; count <= tags.length; count++) {
							initialparams +=
								markerstart +
								markers.TAG +
								count +
								tags[count - 1];
						}
					}

					var key = Sha1.hash(
						Sha1.hash(initialparams + sharedkey) + sharedkey
					);
					var smartlink = url + bin2hex(initialparams) + key;

					console.log("Generate Smartlink Successful!");
					return smartlink;
				} else {
					console.log(
						"Multiline arguments must have the same number of elements!"
					);
				}
			} else {
				console.log("Required arguments are missing!");
			}
		}
	}

	var Sha1 = {};

	/**
	 * Generates SHA-1 hash of string
	 *
	 * @param {String} msg                String to be hashed
	 * @param {Boolean} [utf8encode=true] Encode msg as UTF-8 before generating hash
	 * @returns {String}                  Hash of msg as hex character string
	 */
	Sha1.hash = function (msg, utf8encode) {
		utf8encode = typeof utf8encode == "undefined" ? true : utf8encode;

		// convert string to UTF-8, as SHA only deals with byte-streams
		if (utf8encode) msg = Utf8.encode(msg);

		// constants [§4.2.1]
		var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];

		// PREPROCESSING

		msg += String.fromCharCode(0x80);

		// convert string msg into 512-bit/16-integer blocks arrays of ints [§5.2.1]
		var l = msg.length / 4 + 2;
		var N = Math.ceil(l / 16);
		var M = new Array(N);

		for (var i = 0; i < N; i++) {
			M[i] = new Array(16);
			for (var j = 0; j < 16; j++) {
				M[i][j] =
					(msg.charCodeAt(i * 64 + j * 4) << 24) |
					(msg.charCodeAt(i * 64 + j * 4 + 1) << 16) |
					(msg.charCodeAt(i * 64 + j * 4 + 2) << 8) |
					msg.charCodeAt(i * 64 + j * 4 + 3);
			} // note running off the end of msg is ok 'cos bitwise ops on NaN return 0
		}
		// add length (in bits) into final pair of 32-bit integers (big-endian) [§5.1.1]
		M[N - 1][14] = ((msg.length - 1) * 8) / Math.pow(2, 32);
		M[N - 1][14] = Math.floor(M[N - 1][14]);
		M[N - 1][15] = ((msg.length - 1) * 8) & 0xffffffff;

		// set initial hash value [§5.3.1]
		var H0 = 0x67452301;
		var H1 = 0xefcdab89;
		var H2 = 0x98badcfe;
		var H3 = 0x10325476;
		var H4 = 0xc3d2e1f0;

		// HASH COMPUTATION [§6.1.2]

		var W = new Array(80);
		var a, b, c, d, e;
		for (var i = 0; i < N; i++) {
			// 1 - prepare message schedule 'W'
			for (var t = 0; t < 16; t++) W[t] = M[i][t];
			for (var t = 16; t < 80; t++)
				W[t] = Sha1.ROTL(
					W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16],
					1
				);

			// 2 - initialise five working variables a, b, c, d, e with previous hash value
			a = H0;
			b = H1;
			c = H2;
			d = H3;
			e = H4;

			// 3 - main loop
			for (var t = 0; t < 80; t++) {
				var s = Math.floor(t / 20);
				var T =
					(Sha1.ROTL(a, 5) + Sha1.f(s, b, c, d) + e + K[s] + W[t]) &
					0xffffffff;
				e = d;
				d = c;
				c = Sha1.ROTL(b, 30);
				b = a;
				a = T;
			}

			// 4 - compute the new intermediate hash value
			H0 = (H0 + a) & 0xffffffff;
			H1 = (H1 + b) & 0xffffffff;
			H2 = (H2 + c) & 0xffffffff;
			H3 = (H3 + d) & 0xffffffff;
			H4 = (H4 + e) & 0xffffffff;
		}

		return (
			Sha1.toHexStr(H0) +
			Sha1.toHexStr(H1) +
			Sha1.toHexStr(H2) +
			Sha1.toHexStr(H3) +
			Sha1.toHexStr(H4)
		);
	};

	//
	// function 'f' [§4.1.1]
	//
	Sha1.f = function (s, x, y, z) {
		switch (s) {
			case 0:
				return (x & y) ^ (~x & z); // Ch()
			case 1:
				return x ^ y ^ z; // Parity()
			case 2:
				return (x & y) ^ (x & z) ^ (y & z); // Maj()
			case 3:
				return x ^ y ^ z; // Parity()
		}
	};

	//
	// rotate left (circular left shift) value x by n positions [§3.2.5]
	//
	Sha1.ROTL = function (x, n) {
		return (x << n) | (x >>> (32 - n));
	};

	//
	// hexadecimal representation of a number
	//   (note toString(16) is implementation-dependant, and
	//   in IE returns signed numbers when used on full words)
	//
	Sha1.toHexStr = function (n) {
		var s = "",
			v;
		for (var i = 7; i >= 0; i--) {
			v = (n >>> (i * 4)) & 0xf;
			s += v.toString(16);
		}
		return s;
	};

	var Utf8 = {}; // Utf8 namespace

	/**
	 * Encode multi-byte Unicode string into utf-8 multiple single-byte characters
	 * (BMP / basic multilingual plane only)
	 *
	 * Chars in range U+0080 - U+07FF are encoded in 2 chars, U+0800 - U+FFFF in 3 chars
	 *
	 * @param {String} strUni Unicode string to be encoded as UTF-8
	 * @returns {String} encoded string
	 */
	Utf8.encode = function (strUni) {
		var strUtf = strUni.replace(/[\u0080-\u07ff]/g, function (c) {
			var cc = c.charCodeAt(0);
			return String.fromCharCode(0xc0 | (cc >> 6), 0x80 | (cc & 0x3f));
		});
		strUtf = strUtf.replace(/[\u0800-\uffff]/g, function (c) {
			var cc = c.charCodeAt(0);
			return String.fromCharCode(
				0xe0 | (cc >> 12),
				0x80 | ((cc >> 6) & 0x3f),
				0x80 | (cc & 0x3f)
			);
		});
		return strUtf;
	};

	function bin2hex(s) {
		// http://kevin.vanzonneveld.net
		// +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
		// +   bugfixed by: Onno Marsman
		// +   bugfixed by: Linuxworld
		// +   improved by: ntoniazzi (http://phpjs.org/functions/bin2hex:361#comment_177616)
		// *     example 1: bin2hex('Kev');
		// *     returns 1: '4b6576'
		// *     example 2: bin2hex(String.fromCharCode(0x00));
		// *     returns 2: '00'

		var i,
			l,
			o = "",
			n;

		s += "";

		for (i = 0, l = s.length; i < l; i++) {
			n = s.charCodeAt(i).toString(16);
			o += n.length < 2 ? "0" + n : n;
		}

		return o;
	}
})();
